import Vue from "vue";
import App from "./App";
import router from "./router";
import i18n from "static/js/i18n";
import store from "./store";
import axios from "axios";
import webUtil from "static/js/util";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import clipboard from "vue-clipboard2";
import { Alert, Confirm, Toast } from "wc-messagebox";
import "wc-messagebox/style.css";
import BigNumber from "static/js/bignumber.mjs";
import webCoin from "static/js/coinUnit.js";
import VueLazyload from "vue-lazyload";
import "static/css/index.css";
Vue.use(VueLazyload, {
  preLoad: 1,
  error: require("static/img/chain/default.svg"),
  loading: require("static/img/chain/default.svg"),
  attempt: 1,
});

Vue.config.productionTip = false;
Vue.use(clipboard);

Vue.prototype.webUtil = webUtil;
Vue.prototype.axios = axios;
Vue.prototype.webCoin = webCoin;
Vue.prototype.BigNumber = BigNumber;

var _hmt = _hmt || [];
(function () {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?7fef4ab83184663a4dee3238bed896da";
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
})();

// 混入方法
import { mapGetters, mapActions } from "vuex";

Vue.mixin({
  data() {
    return {
      toastInstance: null,
      root: "/",
      apiLink: "https://api.maiziqianbao.net/apiChain/",
      path: "44'/60'/0'/0/0",
    };
  },
  computed: {
    ...mapGetters({
      account: "account",
      currentChain: "currentChain",
      selectedChain: "selectedChain",
      chainInfo: "chainInfo",
      legalCoin: "legalCoin",
      coinsInfo: "coinsInfo",
      unit: "unit",
    }),
    user() {
      return this.chainInfo ? this.chainInfo.ws : null;
    },
    symbol() {
      return this.chainInfo && this.chainInfo.token
        ? this.chainInfo.token.symbol
        : "ETH";
    },
    decimal() {
      return this.chainInfo && this.chainInfo.token
        ? this.chainInfo.token.decimals
        : 18;
    },
    price() {
      return this.chainInfo && this.chainInfo
        ? parseFloat(this.chainInfo.token.price)
        : 0;
    },
  },
  methods: {
    ...mapActions(["setLegalCoin"]),
    // 复制
    copyAddress(val) {
      if (this.webUtil.browserVersions().android) {
        var oInput = document.createElement("input");
        oInput.type = "text";
        oInput.value = val;
        document.body.appendChild(oInput);
        oInput.select(); // 选择对象
        document.execCommand("Copy"); // 执行浏览器复制命令
        oInput.parentNode.removeChild(oInput); //执行完之后删除该对象
        this.$toast(this.$t("copy_success"));
      } else {
        this.$copyText(val).then(
          (e) => {
            //复制成功的回调
            this.$toast(this.$t("copy_success"));
          },
          (e) => {
            this.$toast(this.$t("copy_fail"));
          }
        );
      }
    },
    // 拉取汇率 1USD = ～RMB
    getCoinPub(nodeUrl) {
      let query = webUtil.getCodeTime();
      let url = nodeUrl + "api/baseCoinPub?v=1.0" + query;
      return new Promise((resolve) => {
        this.axios.get(url).then((res) => {
          if (res.data.success) {
            let response = res.data.data.legal;
            resolve(response);
          }
        });
      });
    },
    coinChange(coin) {
      let coinInfo = this.coinsInfo.filter((item) => {
        return item.alias == coin;
      });
      if (coinInfo.length > 0) {
        this.setLegalCoin(coinInfo[0]);
      }
    },
  },
});

/* eslint-disable no-new */
var vue1 = new Vue({
  router,
  i18n,
  store,
  render: (h) => h(App),
}).$mount("#app");

Vue.use(Alert, {
  title: vue1.$t("prompt"),
  btnText: "OK",
});
Vue.use(Confirm, {
  title: vue1.$t("Confirm"),
});
Vue.use(Toast, {
  duration: 2500,
  // location: 'center',
  // toastStyle: {
  //   height: '60px',
  //   width: '260px',
  //   fontSize: '16px'
  // },
});
